

export function compareDepartures(a, b) {
  return a - b;
}
